import { Box, Paper, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import TooltipWrapper from "../../../../components/TooltipWrapper";
import PercentageLabel from "../../frameworks/components/PercentageLabel";
import TechniqueTooltipContent from "./TechniqueTooltipContent";

const AttackTechnique = ({
  technique,
  onTechniqueClick,
  showRisk,
  isHistoricalView,
}) => {
  const colors = useColors();

  return (
    <Box sx={{ marginBottom: "12px" }}>
      <TooltipWrapper
        name={"Attack Technique Tooltip for " + technique.id}
        content={
          <TechniqueTooltipContent technique={technique} showRisk={showRisk} />
        }
      >
        <Paper
          onClick={
            technique.applicable ? () => onTechniqueClick(technique) : undefined
          }
          sx={{
            height: "68px",
            width: "300px",
            padding: "14px",
            borderRadius: "8px",
            backgroundColor: colors.common_white,
            border: `1px solid ${colors.icon_stroke}`,
            boxShadow: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor:
              technique.applicable && !isHistoricalView ? "pointer" : "default",
            overflow: "hidden",
            "&:hover":
              technique.applicable && !isHistoricalView
                ? {
                    backgroundColor: colors.grey_100,
                  }
                : {},
            "&:last-child": {
              marginBottom: 0,
            },
          }}
        >
          <Typography
            variant="body2"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
              flexGrow: 1,
              marginRight: "16px",
              color: colors.text_primary,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {technique.name}
          </Typography>
          <PercentageLabel
            applicable={technique.applicable}
            percentage={technique.percentage}
            negativePercentage={showRisk}
          />
        </Paper>
      </TooltipWrapper>
    </Box>
  );
};

export default AttackTechnique;
